import { useMemo } from 'react';

import { APPLICATION_GENDER_OPTIONS } from '@lib/utils/constants/applicationConstants';

import { FilterCollapse } from '../components/FilterCollapse';
import { useJobsBoardFiltersModalContext } from '../context';
import { StyledCheckboxGroup } from '../styles';

export const GenderFilter = () => {
  const { modalFilters, setGenders } = useJobsBoardFiltersModalContext();
  const subtitle = useMemo(() => {
    if (!modalFilters?.genders?.length) {
      return 'Any';
    }

    return (
      APPLICATION_GENDER_OPTIONS.filter((gender) =>
        modalFilters?.genders?.includes(gender?.value)
      )
        .map((gender) => gender.label)
        .join(', ') || 'Any'
    );
  }, [modalFilters?.genders]);
  return (
    <FilterCollapse
      title={'Gender'}
      subtitle={subtitle}
      content={
        <StyledCheckboxGroup
          value={modalFilters?.genders ?? []}
          options={APPLICATION_GENDER_OPTIONS}
          onChange={(value) => {
            setGenders(value as string[]);
          }}
        />
      }
    />
  );
};
